import { AccountService } from '@services/account.service'

/**
 * Área de origem de quem não pode abrir a área pedida (RF 18 da spec 048): fornecedor, assinante, agente (no órgão
 * escolhido, ou na escolha do órgão) e, no resto, a escolha de papel.
 */
export function resolveHomeUrl(
	account: Pick<AccountService, 'isSupplier' | 'isSinger' | 'isAppMember' | 'isAppSuperAdmin' | 'roles' | 'hasSessionAccount'>
): string {
	if (account.isSupplier) return '/supplier/board'
	if (account.isSinger) return '/signer/board'

	if (account.isAppMember || account.isAppSuperAdmin || account.roles?.length) {
		return account.hasSessionAccount ? '/dashboard' : '/organization/multi-tenant-select'
	}

	return '/auth/role-select'
}
